<app-rp-loader></app-rp-loader>
<div class="account-pages my-5 pt-sm-5">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-primary-subtle">
            <div class="row">
              <div class="col-8 d-flex align-items-center">
                <div class="text-primary p-4">
                  <h5 class="text-primary"> Forgot Password</h5>
                  <!-- <p>Reset Password with Skote.</p> -->
                </div>
              </div>
              <div class="col-4 align-self-end">
                <div class="d-flex justify-content-center">
                  <img src="assets/images/logo.png" alt="" class="img-fluid w-60 mt-1">
                </div>
                <img src="assets/images/profile-img.png" alt="" class="img-fluid">
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <a routerLink="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="assets/images/logo-mini.png" alt="" class="rounded-circle" height="35">
                  </span>
                </div>
              </a>
            </div>

            <div class="p-2">


              <form class="needs-validation" [formGroup]="resetForm" (ngSubmit)="onSubmit()" name="resetForm"
                novalidate>
                <!-- @if(error){
                  <alert type="danger" [dismissible]="false">{{ error }}</alert>
                  } -->
                <div class="mb-3">
                  <label for="email">Email</label>

                  <input type="email" formControlName="email" class="form-control" id="email"
                    placeholder="Email / Mobile" />
                  @if(submitted && f['email'].errors){
                  <div class="invalid-feedback">
                    @if(f['email'].errors['required']){
                    <div>{{forgotPwdValidations.email_mobile_validation}}</div>}
                    <!-- @if(f['email'].errors['email']){
                      <div>Enter your Email/Mobile number to reset your password</div>} -->
                  </div>}
                </div>
                <div class="text-end">
                  <button class="btn btn-primary w-md" (click)="sendOTP()" type="submit">Send OTP</button>
                </div>

                <div class="alert alert-success text-center mb-4 p-2 mt-3" *ngIf="otpSuccessMsg" role="alert">
                  {{forgotPwdValidations.otp_success_msz}}
                </div>

                <div class="alert alert-danger text-center mb-4 p-2 mt-3" *ngIf="otpErrorMsg" role="alert">
                  {{respMessage.message}}
                </div>

              </form>
            </div>

          </div> <!-- end card-body-->
        </div>
        <!-- end card -->
        <!-- <div class="mt-5 text-center">
            <p>Remember It ? <a routerLink="/auth/login" class="fw-medium text-primary"> Sign In here</a> </p>
          </div> -->

      </div> <!-- end col -->
    </div>
    <!-- end row -->
  </div>
  <!-- end container -->
</div>
<!-- end page -->